import FieldSet from '../../FieldSet';

import { UrlCustomField } from './UrlCustomField';
import { UrlCustomFieldLink } from './UrlCustomFieldLink';
import { UrlCustomFieldLinkIcon } from './UrlCustomFieldLinkIcon';

export class UrlCustomFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [UrlCustomField, UrlCustomFieldLink, UrlCustomFieldLinkIcon];
  }

  get title() {
    return 'Url Custom Field';
  }
}
